export const SYSTEM_STATUS = [
  {
    id: "0",
    label: "Utkast",
    color: "warning",
  },
  {
    id: "1",
    label: "Aktiv",
    color: "success",
  },
  {
    id: "2",
    label: "Avslutad",
    color: "primary",
  },
  {
    id: "3",
    label: "Borttagen",
    color: "error",
  },
  {
    id: "4",
    label: "Pausad",
    color: "error",
  },
  {
    id: "5",
    label: "Matchningsförslag",
    color: "warning",
  },
];
